import { useState } from 'react';

import { NimbuxHotelMedia } from '@bandido/shared/interfaces';

export const useHotelImagesModal = (images: NimbuxHotelMedia[]) => {
  const [modalOpen, setModalOpen] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  const handleImageClick = (index: number) => {
    setCurrentImageIndex(index);
    setModalOpen(true);
  };

  const handleNextImage = () => {
    setCurrentImageIndex((prev) => (prev + 1) % images.length);
  };

  const handlePrevImage = () => {
    setCurrentImageIndex((prev) => (prev - 1 + images.length) % images.length);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
  };

  return {
    modalOpen,
    currentImageIndex,
    handleImageClick,
    handleNextImage,
    handlePrevImage,
    handleCloseModal,
  };
};
